import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";

export default function ModuleEmptyPage() {
  const route_navigate = useNavigate();
  const redux_user = useSelector((state) => state.user);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    setUserData(redux_user?.userDetail);
  }, [redux_user]);

  return (
    <>
      <div className="flex flex-column align-items-center justify-content-center w-full h-full bg-blue-50">
        <div className="text-4xl font-bold text-red-600">查無頁面 !!</div>
        <Button
          className="px-4 mt-4"
          type="button"
          label={!userData ? "回登入頁" : "回首頁"}
          onClick={() =>
            route_navigate(
              !userData
                ? "/login"
                : [8, 9].includes(userData?.type)
                ? "/back/member"
                : "/member"
            )
          }
        />
      </div>
    </>
  );
}
